import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Comandă la masă',
    [ORDER_METHODS.PICKUP]: 'Ridicare',
    [ORDER_METHODS.DELIVERY]: 'Livrare',
  },
};
